import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useTemplateRef } from 'vue'
import WorkspaceSelection from '@/modules/shared/WorkspaceSelection.vue'
import { useWorkspaceList } from '@/composables/useWorkspaceList'
import usePromptTestingWorkspace from '@/modules/settings/composables/usePromptTestingWorkspace'


export default /*@__PURE__*/_defineComponent({
  __name: 'PromptTestingWorkspaceSelection',
  emits: ["switch-workspace"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { activeWorkspace } = usePromptTestingWorkspace()

const tippyTemplateRef = useTemplateRef('tippyRef')

const [workspaces] = useWorkspaceList()

const switchWorkspace = (workspaceId: number) => {
  if (workspaceId === activeWorkspace.value?.id) return
  tippyTemplateRef.value?.tippyRef?.tip.hide()

  activeWorkspace.value = workspaces.value.find((ws) => ws.id === workspaceId)

  emit('switch-workspace', workspaceId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WorkspaceSelection, {
    ref: "tippyRef",
    "shadow-label": "",
    "active-workspace": _unref(activeWorkspace),
    onSwitchWorkspace: switchWorkspace
  }, null, 8 /* PROPS */, ["active-workspace"]))
}
}

})